/* tslint:disable */
/* eslint-disable */
export enum AuthorizedRole {
  Any = 'Any',
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Employee = 'Employee',
  Helper = 'Helper',
  Kiosk = 'Kiosk'
}
